























import {Component, Vue, Watch} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import CompanyForm from "@/forms/CompanyForm.vue";
import AnnouncementForm from "@/forms/AnnouncementForm.vue";

@Component({
    components: {AnnouncementForm, CompanyForm},
    name: "NewCompany",
    computed: {
        ...mapGetters({user: 'user', profile: 'profile', isCompany: 'isCompany', isWorker: 'isWorker'})
    }
})
export default class NewCompany extends Vue {
    private user?: any;
    private profile?: any;

    @Watch('isCompany')
    private changeIsCompany(value: boolean){
        if(value){
            this.$router.push({name: 'Start'}).catch(()=>{});
        }
    }

}
